export default __webpack_public_path__ + "static/media/icn_from_wht.fdc14be5.svg";